import { atom } from 'recoil';
import cloneDeep from 'lodash';

import * as K from 'common/constants';
import { FacetsCompletionInfo } from 'common/types';
import { numericStringCompare } from 'common/util/string';
import { recoilSelector } from 'common/util/recoil-selector';
import { updateFacetCompletionInfoFromSchema } from 'common/util/facets';
import { viewState } from 'components/common/Managers/ViewStateManager.state';
import schemas, { Schema } from 'schemas';

// facet info gleaned from TOP_FACETS and FACET_VALUES responses
export const facetInfoFromDataState = atom<FacetsCompletionInfo>({
  key:     K.RECOIL_ATOM_KEY.FACET_INFO_FROM_DATA,
  default: K.EMPTY_OBJECT as FacetsCompletionInfo,
});

// facet info with schema fields (non-default view) added in
export const facetInfoState = recoilSelector<FacetsCompletionInfo>({
  key:     K.RECOIL_ATOM_KEY.FACET_INFO,
  get: ({ get }) => {
    const facetInfo = get(facetInfoFromDataState);
    const view = get(viewState);
    const schemasToAdd: Schema[] = (view.dataSources || []).map(schemaName => schemas[schemaName]);
    if (schemasToAdd.length === 0) {
      return facetInfo;
    }
    return schemasToAdd.reduce(updateFacetCompletionInfoFromSchema, cloneDeep(facetInfo) as unknown as FacetsCompletionInfo);
  },
});

// list of known facets
export const facetListState = recoilSelector<string[]>({
  key: K.RECOIL_SELECTOR_KEY.FACET_LIST,
  get: ({ get }) => {
    const facetInfo = get(facetInfoState);
    return Object.keys(facetInfo).sort(numericStringCompare);
  },
});

export const facetInfoNeededState = atom<boolean>({
  key:     K.RECOIL_ATOM_KEY.FACET_INFO_NEEDED,
  default: false,
});
